import { useEffect, ReactNode } from "react";
import { useAppDispatch } from "@/store";
import { fetchCurrentUser } from "@/store/slices/authSlice";
import { setOnUnauthorized } from "@/api/axios";
import { clearAuth } from "@/store/slices/authSlice";

export function AuthInit({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchCurrentUser());
    setOnUnauthorized(() => dispatch(clearAuth()));
  }, [dispatch]);

  return <>{children}</>;
}
